import { observer } from 'mobx-react-lite'
import { IDisposer } from 'mobx-state-tree'
import React from 'react'

import { persistModel } from '../../helpers/persistModel'
import { MapContext } from './MapContext'
import { MapModel, TMapModelProps } from './MapModel'

type TProps = Required<SomeChildren> &
  TMapModelProps & {
    persistKey?: string
  }

export const MapProvider = observer<TProps>(
  ({ children, persistKey = 'Map', ...modelProps }) => {
    const [mapModel] = React.useState(() =>
      MapModel.named(persistKey).create(modelProps),
    )

    React.useEffect(() => {
      let dispose: IDisposer | undefined

      persistModel(mapModel).then(dis => {
        dispose = dis
        mapModel.setInitialized()
      })

      return dispose
    }, [mapModel])

    return (
      <MapContext.Provider value={mapModel}>{children}</MapContext.Provider>
    )
  },
)
